import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { mockInterviews } from '../../data/mockData';
import { Interview } from '../../types';

interface InterviewsState {
  items: Interview[];
  loading: boolean;
}

const initialState: InterviewsState = {
  items: mockInterviews,
  loading: false,
};

const interviewsSlice = createSlice({
  name: 'interviews',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    addInterview: (state, action: PayloadAction<Interview>) => {
      state.items.push(action.payload);
    },
  },
});

export const { setLoading, addInterview } = interviewsSlice.actions;

export default interviewsSlice.reducer;
